import * as React from "react";
import { SVGProps } from "react";

const Rise = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1272 2499" {...props}>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <circle cx={200.73} cy={193.05} r={193.05} fill="#8352a1" />
        <circle cx={1066.13} cy={2296.63} r={193.05} fill="#3e99d3" />
        <rect
          width={1488.75}
          height={358.41}
          x={-101.7}
          y={354.69}
          fill="#e53c54"
          rx={172.01}
          transform="rotate(-37.69 642.672 533.893)"
        />
        <rect
          width={1488.75}
          height={358.41}
          x={-101.79}
          y={1060.32}
          fill="#f49352"
          rx={172.01}
          transform="rotate(-37.69 642.586 1239.519)"
        />
        <rect
          width={1488.75}
          height={358.41}
          x={-115.03}
          y={1792.65}
          fill="#3ebb90"
          rx={172.01}
          transform="rotate(-37.69 629.346 1971.847)"
        />
      </g>
    </g>
  </svg>
);

export default Rise;
